import Net from '../../util/net';
import { GetCosSTSTmpCredentialsReq, GetCosSTSTmpCredentialsRsp } from '../../typings/proto';

export async function getCosSession(
  bucket: string,
  region: string,
  appId: string,
): Promise<GetCosSTSTmpCredentialsRsp> {
  const res = await Net.request<GetCosSTSTmpCredentialsRsp, GetCosSTSTmpCredentialsReq>({
    serverName: 'CosSTSSrv',
    funcName: 'GetCosSTSTmpCredentials',
    data: {
      bucket,
      region,
      appId,
    },
  });
  return res;
}
